import { z } from "zod";

/**
 * `metafields` — when this query key is present, show "Category Metafields / Attributes"
 * in Product Details → Catalog Organization (e.g. `?metafields` or `?metafields=1`).
 *
 * `variantId` — set when the user opened a variant via Edit on the Variants page;
 * the sidebar hides the Variants row while it is present.
 */
export const skuStoreSkuDetailSearchSchema = z.object({
  metafields: z.boolean().optional(),
  // The landing taxonomy the user came from, so the breadcrumb can link back.
  // Same-product links keep the current search; links to another product
  // don't, so the origin never leaks onto a product outside it.
  collection: z.string().optional().catch(undefined),
  category: z.string().optional().catch(undefined),
  tag: z.string().optional().catch(undefined),
  // Shopify variant ids are numeric, so a pasted URL parses to a number.
  variantId: z.union([z.string(), z.number()]).transform(String).optional(),
});

export type SkuStoreSkuDetailSearch = z.infer<
  typeof skuStoreSkuDetailSearchSchema
>;
